let RgPipes = /* @__PURE__ */ function(RgPipes$1) {
	RgPipes$1[RgPipes$1["Filter"] = 0] = "Filter";
	RgPipes$1[RgPipes$1["ClearZone"] = 1] = "ClearZone";
	RgPipes$1[RgPipes$1["AddPlots"] = 2] = "AddPlots";
	RgPipes$1[RgPipes$1["SkeletonTailorAnatomy"] = 3] = "SkeletonTailorAnatomy";
	RgPipes$1[RgPipes$1["AddMuscles"] = 4] = "AddMuscles";
	RgPipes$1[RgPipes$1["CalcAnatomyCores"] = 5] = "CalcAnatomyCores";
	RgPipes$1[RgPipes$1["CalcAnatomyEntrances"] = 6] = "CalcAnatomyEntrances";
	RgPipes$1[RgPipes$1["AggNmcs"] = 7] = "AggNmcs";
	RgPipes$1[RgPipes$1["AddCornerCores"] = 8] = "AddCornerCores";
	RgPipes$1[RgPipes$1["AddCorridors"] = 9] = "AddCorridors";
	RgPipes$1[RgPipes$1["SetLevelData"] = 10] = "SetLevelData";
	RgPipes$1[RgPipes$1["AddPodium"] = 11] = "AddPodium";
	RgPipes$1[RgPipes$1["AddTechSpaces"] = 12] = "AddTechSpaces";
	RgPipes$1[RgPipes$1["RemoveEmptyBuildings"] = 13] = "RemoveEmptyBuildings";
	RgPipes$1[RgPipes$1["Resize"] = 14] = "Resize";
	RgPipes$1[RgPipes$1["AddPodiumEmptySpaces"] = 15] = "AddPodiumEmptySpaces";
	RgPipes$1[RgPipes$1["AddOpenings"] = 16] = "AddOpenings";
	RgPipes$1[RgPipes$1["AddRoofAndParapet"] = 17] = "AddRoofAndParapet";
	RgPipes$1[RgPipes$1["AddFacade"] = 18] = "AddFacade";
	RgPipes$1[RgPipes$1["AddPodiumGlazing"] = 19] = "AddPodiumGlazing";
	RgPipes$1[RgPipes$1["GeneratePolygons"] = 20] = "GeneratePolygons";
	RgPipes$1[RgPipes$1["SetBuildingIndexes"] = 21] = "SetBuildingIndexes";
	return RgPipes$1;
}({});
export { RgPipes };

//# sourceMappingURL=index9.js.map